import { roles } from "../../helpers/Authorization/authorizationHelpers";
import EditNotificationPage from "../Notifications/EditNotificationPage";
import ManageNotificationsPage from "../Notifications/ManageNotificationsPage";
import NotificationList from "../Notifications/NotificationList";
import PublishNotificationPage from "../Notifications/PublishNotificationPage";

export default [
  {
    name: "add-notification",
    parent: "root",
    url: "/notification/new",
    component: PublishNotificationPage,
    defaultBreadcrumbItems: [
      { to: "home", label: "breadcrumb.customers", icon: "home" },
      { to: "manage-notifications", label: "manageNotifications" },
      { to: "add-notification", label: "publishNotification" }
    ],
    requiredRoles: [roles.InternalExpert]
  },
  {
    name: "edit-notification",
    parent: "root",
    url: "/notification/:notificationId",
    component: EditNotificationPage,
    defaultBreadcrumbItems: [
      { to: "home", label: "breadcrumb.customers", icon: "home" },
      { to: "manage-notifications", label: "manageNotifications" },
      { to: "edit-notification", label: "editNotification" }
    ],
    requiredRoles: [roles.InternalExpert]
  },
  {
    name: "manage-notifications",
    parent: "root",
    url: "/notification",
    component: ManageNotificationsPage,
    defaultBreadcrumbItems: [
      { to: "home", label: "breadcrumb.customers", icon: "home" },
      { to: "manage-notifications", label: "manageNotifications" }
    ],
    requiredRoles: [roles.InternalExpert]
  },
  {
    name: "notification-list",
    parent: "root",
    url: "/notification-list",
    component: NotificationList,
    defaultBreadcrumbItems: [{ to: "home", label: "breadcrumb.customers", icon: "home" }, { to: "notification-list", label: "notifications" }]
  }
];



// WEBPACK FOOTER //
// ./src/components/Router/notificationStates.js